import React from 'react'
import throttle from 'lodash/throttle'
import * as slideLayoutJSON from '../slideLayout/slideLayoutDefinition.json'


const bodyFontSizeChoices = slideLayoutJSON.SpecialValues.BodyFontSizeArray
const maxHeights = slideLayoutJSON.SpecialValues.CalculatedBodyContainerMaxHeightArray
const bodyMargin= slideLayoutJSON.SpecialValues.BodyFontCalculationBuffer
const throttleInterval=150 //ms

class BodyWrapper extends React.PureComponent{

	constructor(){
		super()
		this.calculateFont=this.calculateFont.bind(this)
		this.calculateFont = throttle(this.calculateFont,throttleInterval)	

		this.state={
			bodyHeight:0,
			bodyFontSize:0,

		}
	}	


	UNSAFE_componentWillReceiveProps(nextProps) {
 		if(this.props.template && this.props.template !==nextProps.template){
 			this.setState({bodyFontSize:0})
 		}
 	}



	componentDidMount(){
		this.mounted=true
		if(this.props.question.xLayout){

			if(this.props.question.xLayout.bodyFS && this.props.question.xLayout.bodyH){
				this.setState({bodyFontSize:this.props.question.xLayout.bodyFS,bodyHeight:this.props.question.xLayout.bodyH})
			}else{
				setTimeout(function() { //Start the timer
					this.calculateFont()
				}.bind(this),	1)
			}}
		else{
			setTimeout(function() { //Start the timer
				this.calculateFont()
			}.bind(this),	1)
		}		
	}

	componentDidUpdate(prevProps) {
		if(this.props.question.questionId!== prevProps.question.questionId){
			if(this.props.question.xLayout){
				if(this.props.question.xLayout.bodyFS){
					this.setState({bodyFontSize:this.props.question.xLayout.bodyFS,bodyHeight:this.props.question.xLayout.bodyH})
				}else{
					setTimeout(function() { //Start the timer
						this.calculateFont()
					}.bind(this),	1)
				}
			}else {

				setTimeout(function() { //Start the timer
					this.calculateFont()
				}.bind(this),	1)

			}
		}
		else if (this.props.question.body !==prevProps.question.body){
			setTimeout(function() { //Start the timer
				this.calculateFont()
			}.bind(this),	1)
		}else if(this.props.question.choices !==prevProps.question.choices || this.props.template !== prevProps.template || this.props.choicesFontSize !== prevProps.choicesFontSize ){
			  setTimeout(function() { //Start the timer
				this.calculateFont()
			}.bind(this),	1)
		}
	}
	
	componentWillUnmount() {
		this.mounted = false
	}



	calculateFont(){
		let newBodyHeight=0
		if(this.bodyElement){
			newBodyHeight=this.bodyElement.clientHeight
		}

		const calculatedBodyContainerHeight=slideLayoutJSON.SpecialValues.CalculatedBodyContainerHeight[this.props.template]
		const numOfBodyFonts=bodyFontSizeChoices.length
		let bodyFontIndex=0
		if(calculatedBodyContainerHeight===false){
			for (var i = (numOfBodyFonts-1); i >-1; i--) {
				const el =this[`ghost${i}`]
				if(el){
					if((el.clientHeight+bodyMargin) < newBodyHeight){
						bodyFontIndex=i
						break				
					}
				}
			}
		}
		else{
			for (var r = (numOfBodyFonts-1); r >-1; r--) {
				const el =this[`ghost${r}`]
				if(el){
					if((el.clientHeight+bodyMargin) < maxHeights[r]){
						bodyFontIndex=r
						newBodyHeight=el.clientHeight+bodyMargin
						break				
					}
				}
			}
		}


   	const newBodyFontSize=bodyFontSizeChoices[bodyFontIndex]

   	if(this.mounted){
   		this.setState({bodyFontSize:newBodyFontSize,bodyHeight:newBodyHeight,isCalculating:false})
   		if(!this.props.isStaticSlide){

   			this.props.updateFontSizes('body',newBodyFontSize,newBodyHeight)
   		}
  	}
 	}


	render(){	
		const {bodyFontSize}=this.state

		let bodyCalcCSS= {fontSize: `${bodyFontSize}px`}
		if(slideLayoutJSON.SpecialValues.CalculatedBodyContainerHeight[this.props.template] === true){	
			bodyCalcCSS={...bodyCalcCSS, height:`calc(${this.state.bodyHeight}px - 6px)`}
		}
		
		const extraCharacter='.' // Append question body with extra character for ghost font size calculation to prevent cursor going off the screen

		return[
	
			React.cloneElement(this.props.children, {style:bodyCalcCSS  , ref:c => {this.bodyElement = c},className:`slide-body ${this.props.question.body === '' ? ' slide-body--empty' : ''}`,key:'real'} )					
			,			
			
			<div key={1}>
				{bodyFontSizeChoices.map((fontSize,i) => {
					return(			
						
						<div className="slide-body is--ghost" style={{fontSize: `${fontSize}px`}} ref={c => {this[`ghost${i}`] = c}} key={fontSize}>
							{this.props.question.body}{extraCharacter}
						</div>	
							
					)
				})}
			</div>
			
		]	
	}	
}


export default BodyWrapper






// WEBPACK FOOTER //
// ./src/components/slides/slideWrappers/BodyWrapper.js